var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-avatar',{attrs:{"size":_vm.size,"icon":_vm.icon,"shape":_vm.shape,"src":_vm.src,"srcSet":_vm.srcSet,"alt":_vm.alt,"fit":_vm.fit},on:{"error":_vm.error}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }